import { ChangeDetectionStrategy, Component, computed, forwardRef, inject, input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Button } from 'primeng/button';
import { Popover } from 'primeng/popover';
import { LocationSearchInputService } from '../location-search-input.service';

@Component({
  selector: 'app-advanced-search-dropdown',
  templateUrl: './advanced-search-dropdown.component.html',
  styleUrls: ['./advanced-search-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Button, Popover],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdvancedSearchDropdownComponent),
      multi: true,
    },
  ],
})
export class AdvancedSearchDropdownComponent implements ControlValueAccessor {
  private readonly locationSearchInputService = inject(LocationSearchInputService);

  advancedSearchOptions = this.locationSearchInputService.advancedSearchOptions;
  hasLabel = input(true);

  label = computed(() => (this.hasLabel() ? 'Advanced Search' : ''));

  selectedValue: any;
  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  selectOption(option: any) {
    this.selectedValue = option.value;
    this.onChange(this.selectedValue); // Notify Angular forms of the change
    this.onTouched(); // Mark as touched
  }
}
